import { ref, watch, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {getUserData} from '@/auth/utils'

export default function useBannersList(){

    const toast = useToast()

    const refBannerListTable = ref(null)
    const refBannerCategoryListTable = ref(null)


    const tableColumns = computed(() => {
        let user_id =  getUserData().id
        let column = [
            {key:'banner_image_path', label:'BANNER'},
            {key:'actions'}
        ];

        if(user_id == 1){
            column = [
                {key:'banner_image_path', label:'BANNER'},
                {key:'user.name', label:'COMPANY'},
                {key:'actions'}
            ]; 
        }
        return column;
    })

    const categoryTableColumns = [
        {key:'label', label:'name'},
        {key:'actions'}
    ]
    const perPage = ref(10)
    const totalBanners = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const categoryOptions = ref([])
    const userFilter = ref(null)
    

    const dataMeta = computed(() => {
        const localItemsCount = refBannerListTable.value ? refBannerListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalBanners.value,
        }
    })

    const showMessage = (title,text,icon, variant) =>{
        toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon,
              variant
            },
        })
    }

    const refetchData = () =>{
        refBannerListTable.value.refresh()
    }

    const getBannerImage = (image) =>  process.env.VUE_APP_IMAGE_URL+image

    watch([currentPage, perPage, searchQuery, userFilter], () => {
        refetchData()
    })

    const userOptions = ref([])

    const fetchOptions = () => {
        store
        .dispatch("app/fetchOptions", {
            users: true
        })
        .then(response => {
            userOptions.value = response.data.users
        })
        .catch(() => {
           console.log('Error fetching options')
        })
    }

    const fetchBanners = (ctx, callback) => {

        store.dispatch('bar-banner/fetchBanners', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            user_id: userFilter.value
        })
        .then(response => {
            //console.log(response.data)
            const { banners, total} = response.data
            callback(banners)
            totalBanners.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                  title: 'Error fetching banners list',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
            })
        })
    }

    onMounted(() => {
        fetchOptions()
    })

    return {
        fetchBanners,
        tableColumns,
        categoryTableColumns,
        perPage,
        currentPage,
        totalBanners,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refBannerListTable,
        refBannerCategoryListTable,
        getBannerImage,
        categoryOptions,
        showMessage,
        userOptions,
        userFilter
    
        //Extra Filters
    }

}